import axios from 'axios'
import api from '../api';
import { postWithChecklistCompletion } from '@/helpers/checklistCompletion';

export default class ManageAssetsService {
    async getAllAssets(obj) {
        return await api.post(`ManageAssets/GetAllAssets`, obj);
    };

    async getCategoryAssets(CategoryId, primaryKeyId) {
        debugger;
        if (CategoryId == "") {
            CategoryId=null
        }
        return await api.get(`ManageAssets/GetCategoryAsset/${CategoryId}/${primaryKeyId}`)
    }

    async addEditAsset(dataModel) {
        return await postWithChecklistCompletion(api, `ManageAssets/AddEditAsset`, dataModel);
    };

    async deleteAsset(obj) {
        return await api.post(`ManageAssets/DeleteAsset`, obj);
    };

    async SaveFile(companyId,userId,formData) {
        return await api.post(`ManageAssets/SaveFile/${companyId}/${userId}`, formData, {
            "Content-Type": "multipart/form-data"
        });
    };

    async SaveDocument(companyId,userId,formData) {
        return await api.post(`ManageAssets/SaveDocument/${companyId}/${userId}`, formData, {
            "Content-Type": "multipart/form-data"
        });
    };
    async SaveDocumentForOcr(companyId, userId, formData,fileinitialname) {
        return await api.post(`ManageAssets/SaveDocumentForOCR/${companyId}/${userId}/${fileinitialname}`, formData, {
            "Content-Type": "multipart/form-data"
        });
    };
    async SaveTicketFile(formData) {
        return await api.post(`ManageAssets/SaveTicketFile`, formData, {
            "Content-Type": "multipart/form-data"
        });
    };

    
    async changeAssetActiveInactiveStatus(id, status) {
        return await api.get(`ManageAssets/ChangeAssetActiveInactiveStatus/${id}/${status}`)
    }
    async SaveUnitFile(formData) {
        return await api.post(`ManageAssets/SaveUnitFile`, formData, {
            "Content-Type": "multipart/form-data"
        });
    };
    async GetPublishAssetAmount(AssetId) {
       
        return await api.get(`ManageAssets/GetPublishAssetAmount/${AssetId}`);
    };

    async PublishRequest(model) {
        return await api.post(`ManageAssets/PublishAssetRequest`, model);
    };


    async changeAssetRequestStatus(StatusChangeModal) {
        return await api.post(`ManageAssets/ChangeAssetRequestStatus`, StatusChangeModal)
    } 

    async changePublishRequestStatus(AssetId, companyId, userId) {
        return await api.get(`ManageAssets/ChangePublishRequestStatus/${AssetId}/${companyId}/${userId}`)
    }
    async CreateDuplicateAsset(assetId) {
        return await api.get(`ManageAssets/CreateDuplicateAsset/${assetId}`)
    }
    async GetPaymentMethods(userId, assetId) {
        debugger;
        return await api.get(`ManageAssets/GetPaymentMethods/${userId}/${assetId}`)
    }
      GetAssetDetail(assetId, userId,ipAddress) {
        return api.get(`ManageAsset/GetAssetDetail/${assetId}/${userId}/${ipAddress}`);
    }
    async AddPaymentDetailsProperty(PayementDetails) {
        return await postWithChecklistCompletion(api, `ManageAsset/AddPaymentDetails`, PayementDetails);
    }
    async ownerList(masterNames, masterKeyText, userId) {
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
    async AddOwner(model) {
        debugger;
        return await api.post(`CompanyUsers/AddUsersAsQuickCheckOut`, model);
    }

}